import type { TextareaProps } from "@mantine/core"
import { AppTextarea } from "@/components/forms"
import type { TQuestionProps } from "./types"

export function QuestionString({
  field,
  comment,
  question,
  autoFocus,
  setComment,
  preview,
  minRows,
  maxRows,
}: TQuestionProps & Pick<TextareaProps, "maxRows" | "minRows">) {
  const { onBlur, onFocus, error } = field || {}

  return (
    <AppTextarea
      size="lg"
      maw={preview ? 400 : undefined}
      minRows={minRows ?? 3}
      maxRows={maxRows ?? 5}
      error={error}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={preview}
      autoFocus={autoFocus}
      value={comment ?? ""}
      required={question.is_required}
      onChange={(value) => setComment(value.length > 0 ? value : null)}
    />
  )
}
